<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">异常订单号</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>信息状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>封号状态：</label>
          <el-select v-model="forbiddenState" placeholder="Select" style="width: 8em">
            <el-option v-for="item in forbiddenStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <ChannelPackageList :packageName="packageName" :channel="channel" @getChange="getChannelPackage" />
        </div>
        <div class="content-input-item" v-show="type === 99">
          <label>支付方式：</label>
          <el-select v-model="payType" placeholder="Select" style="width: 10em">
            <el-option v-for="item in payTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="上传时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
          <el-checkbox style="margin-left: 8px;" v-model="limitState">限制</el-checkbox>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="warning" @click="batchForbidden">封号&冻结设备</el-button>
          <el-button type="primary" @click="uploadOrder">上传异常订单号</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            v-loading="listLoading"
            @selection-change="selsChange"
            @header-click="selsAll"
        >
          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
          <el-table-column property="createTime" label="付款ID" v-if="checkColList.indexOf('付款ID') > -1" >
            <template #default="scope">
              <span>{{scope.row.payType == 1? '支付宝：' : scope.row.payType == 2? '微信：' : ''}}</span>
              <span>{{scope.row.buyerId}}</span>
            </template>
          </el-table-column>
          <el-table-column property="buyerAccount" label="付款账号" v-if="checkColList.indexOf('付款账号') > -1" />
          <el-table-column property="createTime" label="生成时间" v-if="checkColList.indexOf('生成时间') > -1" />
          <el-table-column property="payTime" label="购买时间" v-if="checkColList.indexOf('购买时间') > -1" />
          <el-table-column property="orderNumber" label="异常订单号" v-if="checkColList.indexOf('异常订单号') > -1" />
          <el-table-column property="subject" label="订单商品" v-if="checkColList.indexOf('订单商品') > -1" />
          <el-table-column label="头像" v-if="checkColList.indexOf('头像') > -1" width="120">
            <template #default="scope">
              <el-image style="width: 80px; height: 80px" :src="scope.row.headImg.smallHeadImg" @click="showImg(scope.row)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column label="用户信息" v-if="checkColList.indexOf('用户信息') > -1" width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,city"/>
            </template>
          </el-table-column>
          <el-table-column property="regTime" label="注册时间" v-if="checkColList.indexOf('注册时间') > -1" />
          <el-table-column label="信息状态" v-if="checkColList.indexOf('信息状态') > -1" width="180">
            <template #default="scope">
              <p>基本信息：<span>{{scope.row.resumeState==0?'未提交':scope.row.resumeState==1?'待审核':scope.row.resumeState==2?'审核通过':scope.row.resumeState==3?'审核不通过':''}}</span></p>
              <p>封号状态：<span :style="{color: scope.row.isForbidden?'red':''}">{{ scope.row.isForbidden?'已封号':'未封号'}}</span></p>
              <p>冻结设备：<span :style="{color: scope.row.isIdfaBan?'red':''}">{{ scope.row.isIdfaBan?'已冻结':'未冻结'}}</span></p>
            </template>
          </el-table-column>
          <el-table-column label="认证情况" v-if="checkColList.indexOf('认证情况') > -1" width="180">
            <template #default="scope">
              <p>身份认证：{{scope.row.identityAuth.identityState == 0 ? "未认证未提交" : scope.row.identityAuth.identityState == 1 ? "申请认证" : scope.row.identityAuth.identityState == 2 ? "已认证" : scope.row.identityAuth.identityState == 3 ? "认证不通过" : scope.row.identityAuth.identityState == 4 ? "正面认证不通过" : scope.row.identityAuth.identityState == 5 ? "反面认证不通过" : ""}}</p>
              <p>芝麻认证：{{scope.row.identityAuth.zhimaState == 0 ? "不通过" : scope.row.identityAuth.zhimaState == 1 ? "通过" : ""}}</p>
              <p>百度认证：{{scope.row.identityAuth.baiduState == 0 ? "不通过" : scope.row.identityAuth.baiduState == 1 ? "通过" : ""}}</p>
              <p>视频认证：<span v-if="scope.row.authVideo">{{scope.row.authVideo.state == 1 ? "待审核" : scope.row.authVideo.state == 2 ? "审核通过" : scope.row.authVideo.state == 3 ? "审核不通过" : ""}}</span></p>
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponentsAbnormal'
// import BtnGroup from '../../components/BtnGroup'
import SearchUidOrPhone from '../../components/SearchUidOrPhone'
import {getAbnormalOrderPageList, getGoldDetailType} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from '../../assets/js/dialog'
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import UserLog from "@/components/UserLog/UserLog";
import ChannelPackageList from "@/components/resume/ChannelPackageList_c";
import ForbiddenDialog from "@/components/resume/ForbiddenDialog";
import UploadOrderDialog from "@/views/data/components/UploadOrderDialog";

export default {
  name: "DataAbnormalOrder",
  components: { DatePickerRange, SearchComponents, SearchUidOrPhone, UserLog, ChannelPackageList },
  data() {
    return {

      limitState: false,

      stateArray: [
        {label: '不限', value: -1},
        {label: '未提交', value: 0},
        {label: '待审核', value: 1},
        {label: '已通过', value: 2},
        {label: '未通过', value: 3},
      ],
      state: -1,

      forbiddenStateArray: [
        {label: '不限', value: -1},
        {label: '未封号', value: 0},
        {label: '已封号', value: 1},
      ],
      forbiddenState: -1,

      payTypeArray: [
        {label: '不限', value: -1},
        {label: '支付宝', value: 1},
        {label: '微信', value: 2},
      ],
      payType: -1,

      //渠道、包名
      packageName: 0,
      channel: 0,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //搜索
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['付款ID', '付款账号', '生成时间', '购买时间', '异常订单号', '订单商品', '头像', '用户信息', '注册时间', '信息状态', '认证情况', '用户日志',],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

      dataSummary: [],
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '昵称', value : 2},
        {label : '用户ID', value : 3},
        {label : '付款ID', value : 4},
        {label : '付款账户', value : 5},
      ],

      idArray: [],

    }
  },
  methods: {

    //渠道包名
    getChannelPackage(val) {
      // console.log(val)
      this.packageName = val[0];
      this.channel = val[1];
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.limitState = false;
      this.forbiddenState = -1;
      this.payType = -1;
      this.searchValue = '';
      this.channel = 0;
      this.packageName = 0;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.userId);
      // console.log(this.idArray)
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.userId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },


    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
          // this.getSummarydata();
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      param['forbiddenState'] = this.forbiddenState;
      param['payType'] = this.payType;
      param['packageNameId'] = this.packageName;
      param['channelId'] = this.channel;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['limitState'] = this.limitState?1:0;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getAbnormalOrderPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {

      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }


    },

    batchForbidden() {
      if(this.idArray.length > 0) {
        Dialog.open({
          title: '是否确定封号？',
          component: ForbiddenDialog,
          data: {
            idArray: this.idArray,
            width: '500px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一个用户进行操作',
          type: 'warning'
        })
      }
    },

    uploadOrder() {
      Dialog.open({
        title: '上传异常订单号',
        component: UploadOrderDialog,
        data: {
          width: '600px'
        },
        confirm: () => {
          this.getPage()
        }
      })
    }

  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage(true);
  }
}
</script>

<style scoped>

</style>
